import { useRef, useState, FC } from "react";
import { View, StyleSheet } from "react-native";
import { Helmet } from "react-helmet";
import SelectPayorModal from "../OneIncModel/SelectPayorModal";
import PaymentConfirmationModal from "./PaymentConfirmationModal";
import { introspectionAPI } from "@lib";
import { messages } from "../../resources/strings";
import { theme } from "../../theme/theme";

interface Props {
  refetchData: () => void;
  onClose: () => void;
  onError: (error: any) => void;
}

const Payments: FC<Props> = ({ onClose, onError, refetchData }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentConfirmationModalVisible, setPaymentConfirmationModalVisible] =
    useState(true);
  const portalOneRef = useRef(null);

  const scriptUrl = `${process.env.REACT_APP_ONE_INC_BASE_URL}/GenericModalV2/PortalOne.js?purejs`;

  const closeModal = () => setShowPaymentModal(false);

  const handleIntrospectionCheck = async () => {
    const isIntrospectionValid = await introspectionAPI();
    if (isIntrospectionValid?.response) {
      setPaymentConfirmationModalVisible(false);
      setShowPaymentModal(true);
    } else {
      onError(messages.error.sessionExpired);
    }
  };
  const onCloseConfirmationModal = () => {
    setPaymentConfirmationModalVisible(false);
    onClose();
  };

  const onPaymentModalClose = () => {
    refetchData();
    onClose();
  };
  return (
    <View style={styles.container}>
      <Helmet>
        <script src={scriptUrl} defer type="text/javascript" />
      </Helmet>

      <View
        id="portalOneContainer"
        ref={portalOneRef}
        style={styles.paymentPortal}
      />

      {paymentConfirmationModalVisible && (
        <PaymentConfirmationModal
          onClose={onCloseConfirmationModal}
          onContinue={handleIntrospectionCheck}
        />
      )}
      {showPaymentModal && (
        <View>
          <SelectPayorModal
            containerRef={portalOneRef}
            closePayeeModal={closeModal}
            onError={onError}
            onClose={onPaymentModalClose}
          />
        </View>
      )}
    </View>
  );
};

export default Payments;

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // height: "100%",
    height: theme.height,
    width: theme.width,
  },
  paymentPortal: {
    position: "absolute",
  },
});
